import Swiper from 'swiper/js/swiper';
// import AOS from '@/components/aos';
import '~/sass/pages/homepage.scss';

const { $ } = window;

let swiperShow = null;

const initSwiperShow = () => {
  swiperShow = new Swiper('.swiper-show .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    // centerInsufficientSlides: true,
    freeMode: true,
    freeModeSticky: true,
    freeModeMomentumVelocityRatio: 0.5,
    freeModeMomentumRatio: 0.5,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: '#car-show .swiper-button-next',
      prevEl: '#car-show .swiper-button-prev',
    },
    breakpoints: {
      768: { // 當螢幕寬度 >= 768
        centerInsufficientSlides: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
      },
      1024: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
      1200: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
      1440: {
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        centeredSlides: true,
      },
    },
  });

  // let carShow1 = true;
  // $('#car-show .scroll-menu-list a').on('click', () => {
  //   // const Athis = $(this);
  //   if (carShow1 === false) {
  //     $('#car-show-1').fadeIn(500);
  //     $('#car-show-2').hide();
  //     carShow1 = true;
  //   } else {
  //     $('#car-show-1').hide();
  //     $('#car-show-2').fadeIn(500);
  //     carShow1 = false;
  //   }
  //   swiperShow[0].slideTo(0);
  // });
};

const carShowcase = (group, el) => {
  $(group).find(el).hover(function off() {
    $(group).find(el).not(this).toggleClass('off');
  });
};

$(document).ready(() => {
  console.log('index model car');
  initSwiperShow();

  // 車款類型過濾
  const $cars = $('#car-show .swiper-block .swiper-wrapper .swiper-slide');

  $('#car-show .scroll-menu .scroll-menu-wrapper .scroll-menu-list .type-text').on('click', function filter() {
    const $this = $(this);
    if ($this.data('name') === '') {
      $cars.show();
    } else {
      $cars.hide();
      $cars.each((index, ele) => {
        const $ele = $(ele);
        if ($ele.data('typ').toString().split(',').indexOf($this.data('name').toString()) > -1) {
          $ele.show();
        }
      });
    }
    swiperShow.slideTo(0, 500, false);
    swiperShow.update();
  });

  $('.scroll-menu:not(.tab-group) .type-text').click(function active() {
    $(this).addClass('active');
    $('.scroll-menu .type-text').not(this).removeClass('active');
  });
  carShowcase('.swiper-show', '.car-show-list');
  // AOS.refresh();
});
